<template>
	<c-dialog ref="editGroup" title="选择分类" width="400" height="400" @resolve="submit">
		<dl v-for="(group, i) in groupList" :key="i" class="group">
			<dt><c-checkbox v-model="group.checked" :disabled="group.chlidren.length > 0">{{group.group_name}}</c-checkbox></dt>
			<dd v-if="group.chlidren.length">
				<ul>
					<li v-for="(item, j) in group.chlidren" :key="j"><c-checkbox v-model="item.checked" @click="checkHandle($event, item, group)">{{item.group_name}}</c-checkbox></li>
				</ul>
			</dd>
		</dl>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return {
				groupList: []
			}
		},
		
		mounted() {
			this.update();
		},
		
		methods: {
			open(id, value) {
				if (!id.length) {
					this.$message({
						message: '请选择要分类的商品'
					});
					return;
				}
				
				value && (value = value.split(','));
				!function loop(list) {
					list.forEach(item => {
						this.$set(item, 'checked', value ? value.includes(item.id.toString()) : false);
						loop.call(this, item.chlidren);
					})
				}.call(this, this.groupList);
				
				this._productId = id;
				this.$refs.editGroup.open();
			},
			
			update() {
				this.request({
					url: '/product_group/all_list',
					success: data => {
						this.groupList = data;
					}
				});
			},
			
			checkHandle(state, item, group) {
				this.$set(item, 'checked', state);
				if (state) {
					this.$set(group, 'checked', true);
				} else if (!group.chlidren.find(item => item.checked)) {
					this.$set(group, 'checked', false);
				}
			},
			
			submit(stop, next) {
				stop();
				let arr = [];
				this.groupList.forEach(group => {
					group.checked && arr.push(group.id);
					group.chlidren.forEach(item => {
						item.checked && arr.push(item.id);
					});
				});
				
				if (!arr.length) {
					this.$message({
						message: '请选择分类'
					});
					return;
				}
				
				this.request({
					url: '/product/set_group',
					data: {
						group_ids: arr,
						product_ids: this._productId
					},
					success: data => {
						next();
						this.$message({
							message: '设置成功'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.group {
		padding: 0 40px;
		margin: 20px 0;
		
		dt {
			padding: 5px 0;
		}
		
		dd {
			padding: 0 30px;
			
			li {
				padding: 5px 0;
			}
		}
	}
</style>
